export const IMG_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "description", "smallImageUrl", "mediumImageUrl", "largeImageUrl", "detailImageUrl", "originalImageUrl" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product Name ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "smallImageUrl",
            "title" : "Small Image"
        }, {
            "name" : "mediumImageUrl",
            "title" : "Medium Image"
        }, {
            "name" : "largeImageUrl",
            "title" : "Large Image"
        }, {
            "name" : "detailImageUrl",
            "title" : "Detail Image"
        }, {
            "name" : "originalImageUrl",
            "title" : "Original Image"
        } ],
        "formName" : "ListProductCategoryMembers",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Product Name ID",
            "type" : "HYPERLINK",
            "target" : "ListImageGallery",
            "name" : "productId",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            } ],
            "style" : "",
            "id" : "ListProductCategoryMembers_productId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event":"master-detail",
            "formData":{
                "formName":"ProductImages",
                "formLocation":"component://kwikstore/widget/ImageManagementForms.xml",
                "listType":"grid",
                "viewIndex":1,
                "endPoint":"listImageGallery",
                "link":"/admin/img/product-galleries/gallery/product-images/${productId}/master-detail"
              }
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "isSortField" : "Y",
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_description",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "smallImageUrl",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_smallImageUrl",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mediumImageUrl",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_mediumImageUrl",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "largeImageUrl",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_largeImageUrl",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "detailImageUrl",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_detailImageUrl",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "originalImageUrl",
            "description" : "",
            "style" : "",
            "id" : "ListProductCategoryMembers_originalImageUrl",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "dataResourceId", "productContentTypeId", "productImage" ]
        } ],
        "columns" : [ {
            "name" : "contentId",
            "title" : "Content ID"
        }, {
            "name" : "dataResourceId",
            "title" : "Data Resource ID"
        }, {
            "name" : "productContentTypeId",
            "title" : "Product Content Type ID"
        }, {
            "name" : "productImage",
            "title" : "Product Image"
        } ],
        "formName" : "ProductImages",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "list",
        "fields" : [ {
            "name":"details",
            "title":"Details",
            "type":"COMPOSITE",
            "innerFields":[
                {
                    "name" : "contentId",
                    "title" : "Content ID"
                }, {
                    "name" : "dataResourceId",
                    "title" : "Data Resource ID"
                }, {
                    "name" : "productContentTypeId",
                    "title" : "Product Content Type ID"
                }
            ]
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentId",
            "description" : "",
            "style" : "",
            "id" : "ProductImages_contentId",
            "title" : "Content ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "dataResourceId",
            "description" : "",
            "style" : "",
            "id" : "ProductImages_dataResourceId",
            "title" : "Data Resource ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productContentTypeId",
            "description" : "",
            "style" : "",
            "id" : "ProductImages_productContentTypeId",
            "title" : "Product Content Type ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productImage",
            "description" : "",
            "style" : "",
            "id" : "ProductImages_productImage",
            "title" : "Product Image",
            "type" : "IMAGE",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "imageResize", "additionalImageOne", "additionalImageTwo", "additionalImageThree", "additionalImageFour", "additionalImageFive", "additionalImageSix", "additionalImageSeven", "additionalImageEight", "additionalImageNine", "additionalImageTen", "submitButton" ]
        } ],
        "formName" : "AddMultipleImages",
        "altTarget" : [ ],
        "targets":{
            "createTarget":"addImageForProduct"
        },
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddMultipleImages_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Select Size",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddMultipleImages",
            "options" : [ {
            "description" : "Do not resize",
            "key" : ""
            }, {
            "description" : "100 X 75 (avatar)",
            "key" : "100x75"
            }, {
            "description" : "150 X 112 (thumbnail)",
            "key" : "150x112"
            }, {
            "description" : "320 X 240 (for websites and email)",
            "key" : "320x240"
            }, {
            "description" : "640 X 480 (for message boards)",
            "key" : "640x480"
            }, {
            "description" : "800 X 600 (15-inch monitor)",
            "key" : "800x600"
            }, {
            "description" : "1024 X 768 (17-inch monitor)",
            "key" : "1024x768"
            }, {
            "description" : "1280 X 1024 (19-inch monitor)",
            "key" : "1280x1024"
            }, {
            "description" : "1600 X 1200 (21-inch monitor)",
            "key" : "1600x1200"
            } ],
            "disabled" : "false",
            "id" : "AddMultipleImages_imageResize",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "imageResize",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 1",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageOne",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageOne",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 2",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageTwo",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageTwo",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 3",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageThree",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageThree",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 4",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageFour",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageFour",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 5",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageFive",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageFive",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 6",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageSix",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageSix",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 7",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageSeven",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageSeven",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 8",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageEight",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageEight",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 9",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageNine",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageNine",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Additional Image 10",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "additionalImageTen",
            "style" : "",
            "id" : "AddMultipleImages_additionalImageTen",
            "value" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddMultipleImages",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "",
            "id" : "AddMultipleImages_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addImageForProduct"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "action", "description", "sequenceNum", "drIsPublic", "drDataResourceName", "statusId", "productId", "productContentTypeId", "contentId", "contentIdTo", "dataResourceId", "fromDate", "_rowSubmit", "defaultImage", "viewButton", "deleteButton" ]
        } ],
        "columns" : [ {
            "name" : "drObjectInfo",
            "title" : "Image"
        }, {
            "name" : "action",
            "title" : "Action"
        }, {
            "name" : "description",
            "title" : "Caption"
        }, {
            "name" : "sequenceNum",
            "title" : "Sort Order"
        }, {
            "name" : "drIsPublic",
            "title" : "Public"
        }, {
            "name" : "drDataResourceName",
            "title" : "Image Name"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "_rowSubmit",
            "title" : " "
        }, {
            "name" : "defaultImage",
            "title" : "Default Image"
        }, {
            "name" : "viewButton",
            "title" : "View"
        }, {
            "name" : "deleteButton",
            "title" : "Remove"
        } ],
        "formName" : "ListImageManage",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "multi",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListImageManage_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productContentTypeId",
            "action" : "",
            "id" : "ListImageManage_productContentTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contentId",
            "action" : "",
            "id" : "ListImageManage_contentId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contentIdTo",
            "action" : "",
            "id" : "ListImageManage_contentIdTo",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "dataResourceId",
            "action" : "",
            "id" : "ListImageManage_dataResourceId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "fromDate",
            "action" : "",
            "id" : "ListImageManage_fromDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "alternate" : "Fokof",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageManage_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        },{
            "fieldHelpText" : "",
            "name" : "drIsPublic",
            "alternate" : "Fokof",
            "action" : "",
            "id" : "ListImageManage_drObjectInfo",
            "title" : "Public",
            "type" : "CHECK",
            "event" : "",
            "value" : ""
        },
        {
            "fieldHelpText" : "",
            "ajaxEnabled" : true,
            "size" : 0,
            "name" : "drDataResourceName",
            "description" : "",
            "style" : "",
            "id" : "description",
            "title" : "Caption",
            "type" : "DISPLAY",
            "imageLocation" : ""
            /* "inPlaceEditor" : {
            "cancel" : "Cancel",
            "select" : "true'",
            "method" : "POST",
            "submit" : "OK",
            "inPlaceEditorUrl" : "renameImage",
            "cssclass" : "inplaceeditor-form",
            "name" : "drDataResourceName",
            "type" : "textarea",
            "rows" : "1",
            "cols" : "40",
            "submitdata" : "{productId:'null',contentId:'null'}"
            }, */
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListImageManage_descriptionId",
            "title" : "",
            "type" : "INPUT",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListImageManage_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, { 
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ListImageManage_statusId",
            "title" : "",
            "type" : "SEQUENCE",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "View",
            "title" : "View",
            "type" : "HYPERLINK",
            "target" : "",
            "name" : "viewButton",
            "width" : "",
            "parameterList" : [ ],
            "style" : "view-button",
            "id" : "ListImageManage_viewButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "Remove",
            "type" : "HYPERLINK",
            "target" : "removeImage",
            "name" : "deleteButton",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "productId",
                "bracketedOriginal" : "${productId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "productId"
            },
            "name" : "productId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "contentId",
                "bracketedOriginal" : "${contentId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "contentId"
            },
            "name" : "contentId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "productContentTypeId",
                "bracketedOriginal" : "${productContentTypeId}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "productContentTypeId"
            },
            "name" : "productContentTypeId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "fromDate",
                "bracketedOriginal" : "${fromDate}",
                "isAscending" : true,
                "empty" : false,
                "originalName" : "fromDate"
            },
            "name" : "fromDate"
            } ],
            "style" : "delete-button",
            "id" : "ListImageManage_deleteButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "setImageDetail?productId=${parameters.productId}"
    },
    {
        "formName" : "ShowDefaultImage",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "single",
        "fields" : [ {
            "name" : "drObjectInfo",
            "description" : " ",
            "alternate" : " ",
            "action" : "",
            "style" : "cssImgLarge",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "name" : "drObjectInfo",
            "description" : " ",
            "alternate" : " ",
            "action" : "",
            "style" : "cssImgLarge",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "drObjectInfo", "drDataResourceName", "fromDate", "status", "removeContent" ]
        } ],
        "columns" : [ {
            "name" : "drObjectInfo",
            "title" : "Image"
        }, {
            "name" : "drDataResourceName",
            "title" : "Image Name"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "status",
            "title" : "Status"
        }, {
            "name" : "removeContent",
            "title" : "Delete"
        } ],
        "formName" : "ListImageUpload",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "ListImageUpload_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageUpload_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageUpload_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "drDataResourceName",
            "description" : "",
            "style" : "",
            "id" : "ListImageUpload_drDataResourceName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListImageUpload_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "status",
            "description" : "Uploaded",
            "style" : "",
            "id" : "ListImageUpload_status",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Delete",
            "title" : "Delete",
            "type" : "HYPERLINK",
            "target" : "removeImageUpload",
            "name" : "removeContent",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "name" : "contentId"
            }, {
            "name" : "productContentTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "style" : "",
            "id" : "ListImageUpload_removeContent",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "drDataResourceName", "fromDate", "statusId", "viewButton" ]
        } ],
        "columns" : [ {
            "name" : "drObjectInfo",
            "title" : "Image"
        }, {
            "name" : "drDataResourceName",
            "title" : "Image Name"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "viewButton",
            "title" : "View"
        } ],
        "formName" : "ListImageExist",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageExist_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageExist_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Image Name",
            "type" : "HYPERLINK",
            "target" : "ListImageReplace",
            "name" : "drDataResourceName",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "contentId",
                "bracketedOriginal" : "${contentId}",
                "isAscending" : true,
                "originalName" : "contentId",
                "empty" : false
            },
            "name" : "contentIdExist"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "dataResourceId",
                "bracketedOriginal" : "${dataResourceId}",
                "isAscending" : true,
                "originalName" : "dataResourceId",
                "empty" : false
            },
            "name" : "dataResourceIdExist"
            } ],
            "style" : "",
            "id" : "ListImageExist_drDataResourceName",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListImageExist_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListImageExist_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "View",
            "title" : "View",
            "type" : "HYPERLINK",
            "target" : "",
            "name" : "viewButton",
            "width" : "",
            "parameterList" : [ ],
            "style" : "",
            "id" : "ListImageExist_viewButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""
    },
    {

        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "drDataResourceName", "fromDate", "statusId", "viewButton" ]
        } ],
        "columns" : [ {
            "name" : "drObjectInfo",
            "title" : "Image"
        }, {
            "name" : "drDataResourceName",
            "title" : "Image Name"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "viewButton",
            "title" : "View"
        } ],
        "formName" : "ListImageReplace",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageReplace_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ListImageReplace_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Image Name",
            "type" : "HYPERLINK",
            "target" : "ListImageReplace",
            "name" : "drDataResourceName",
            "width" : "",
            "parameterList" : [ {
            "name" : "productId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "contentId",
                "bracketedOriginal" : "${contentId}",
                "isAscending" : true,
                "originalName" : "contentId",
                "empty" : false
            },
            "name" : "contentIdReplace"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "dataResourceId",
                "bracketedOriginal" : "${dataResourceId}",
                "isAscending" : true,
                "originalName" : "dataResourceId",
                "empty" : false
            },
            "name" : "dataResourceIdReplace"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "parameters.contentIdExist",
                "bracketedOriginal" : "${parameters.contentIdExist}",
                "isAscending" : true,
                "originalName" : "parameters.contentIdExist",
                "empty" : false
            },
            "name" : "contentIdExist"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "parameters.dataResourceIdExist",
                "bracketedOriginal" : "${parameters.dataResourceIdExist}",
                "isAscending" : true,
                "originalName" : "parameters.dataResourceIdExist",
                "empty" : false
            },
            "name" : "dataResourceIdExist"
            } ],
            "style" : "",
            "id" : "ListImageReplace_drDataResourceName",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListImageReplace_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "ListImageReplace_statusId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "View",
            "title" : "View",
            "type" : "HYPERLINK",
            "target" : "",
            "name" : "viewButton",
            "width" : "",
            "parameterList" : [ ],
            "style" : "",
            "id" : "ListImageReplace_viewButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "deleteButton" ]
        } ],
        "columns" : [ {
            "name" : "mapKey",
            "title" : "Size"
        }, {
            "name" : "deleteButton",
            "title" : "Remove"
        } ],
        "formName" : "SizeListOfProduct",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mapKey",
            "description" : "",
            "style" : "",
            "id" : "SizeListOfProduct_mapKey",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "Remove",
            "title" : "Remove",
            "type" : "HYPERLINK",
            "target" : "removeImageBySize",
            "name" : "deleteButton",
            "width" : "",
            "parameterList" : [ {
            "fromField" : {
                "isEmpty" : false,
                "original" : "parameters.productId",
                "bracketedOriginal" : "${parameters.productId}",
                "isAscending" : true,
                "originalName" : "parameters.productId",
                "empty" : false
            },
            "name" : "productId"
            }, {
            "fromField" : {
                "isEmpty" : false,
                "original" : "mapKey",
                "bracketedOriginal" : "${mapKey}",
                "isAscending" : true,
                "originalName" : "mapKey",
                "empty" : false
            },
            "name" : "mapKey"
            } ],
            "style" : "",
            "id" : "SizeListOfProduct_deleteButton",
            "imageTitle" : "",
            "parameterMap" : {
            "productId" : "GZ-2644"
            },
            "height" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "size", "submitButton" ]
        } ],
        "formName" : "ImageResize",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "single",
        "fields" : [ {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Resize Option",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ImageResize",
            "options" : [ {
            "description" : "Resize All Images",
            "key" : "resizeAllImages"
            }, {
            "description" : "Create New Thumbnail Size",
            "key" : "createNewThumbnail"
            } ],
            "disabled" : "false",
            "id" : "ImageResize_resizeOption",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "resizeOption",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "ImageResize",
            "id" : "ImageResize_productId",
            "event" : "",
            "value" : "GZ-2644",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productId",
            "style" : "",
            "id" : "ImageResize_productId",
            "title" : "Choose Product ID",
            "type" : "LOOKUP"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Image Width",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "size",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "ImageResize_size",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ImageResize",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ImageResize_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "resizeImages"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "statusProductId", "_rowSubmit", "drObjectInfo", "checkStatusId", "drDataResourceName", "contentId", "dataResourceId", "fromDate", "viewButton" ]
        } ],
        "columns" : [ {
            "name" : "productId",
            "title" : "Product Name [Product ID] - Category Name"
        }, {
            "name" : "statusProductId",
            "title" : "Product Status"
        }, {
            "name" : "_rowSubmit",
            "title" : " "
        }, {
            "name" : "drObjectInfo",
            "title" : "Image"
        }, {
            "name" : "checkStatusId",
            "title" : "Status"
        }, {
            "name" : "drDataResourceName",
            "title" : "Image Name"
        }, {
            "name" : "contentId",
            "title" : "Content ID"
        }, {
            "name" : "dataResourceId",
            "title" : "ContentDataResourceId"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "viewButton",
            "title" : "View"
        } ],
        "formName" : "ImageApprove",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "multi",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "Round Gizmo [GZ-2644] - ",
            "style" : "",
            "id" : "ImageApprove_productId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "statusProductId",
            "style" : "",
            "id" : "ImageApprove_statusProductId",
            "title" : "Product Status",
            "type" : "RADIO"
        }, {
            "alert" : "false",
            "conditionGroup" : "",
            "tabindex" : "",
            "name" : "_rowSubmit",
            "className" : "hidden",
            "disabled" : "false",
            "id" : "ImageApprove__rowSubmit",
            "type" : "CHECK",
            "event" : "",
            "items" : {
            "description" : " ",
            "value" : "Y"
            },
            "allChecked" : "true"
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ImageApprove_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "drObjectInfo",
            "description" : "Image",
            "alternate" : "Image",
            "action" : "",
            "style" : "cssImgLarge",
            "id" : "ImageApprove_drObjectInfo",
            "title" : "Image",
            "type" : "IMAGE",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "checkStatusId",
            "style" : "",
            "id" : "ImageApprove_checkStatusId",
            "title" : "Status",
            "type" : "RADIO"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "drDataResourceName",
            "description" : "",
            "style" : "",
            "id" : "ImageApprove_drDataResourceName",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentId",
            "description" : "",
            "style" : "",
            "id" : "ImageApprove_contentId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "dataResourceId",
            "description" : "",
            "style" : "",
            "id" : "ImageApprove_dataResourceId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ImageApprove_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "View",
            "title" : "View",
            "type" : "HYPERLINK",
            "target" : "",
            "name" : "viewButton",
            "width" : "",
            "parameterList" : [ ],
            "style" : "",
            "id" : "ImageApprove_viewButton",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "updateStatusImageManagement"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "productId", "productContentTypeId", "contentName", "description", "statusId", "dataResourceId", "uploadedFile", "objectInfo", "submit" ]
        } ],
        "formName" : "EditProductImage",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "single",
        "fields" : [ {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Content ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "contentId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductImage_contentId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Product ID",
            "type" : "DISPLAY",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "productId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductImage_productId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Content Type ID",
            "type" : "DISPLAY",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductImage",
            "options" : [ {
            "description" : "Image - Small",
            "key" : "SMALL_IMAGE_URL"
            }, {
            "description" : "Image - Medium",
            "key" : "MEDIUM_IMAGE_URL"
            }, {
            "description" : "Image - Large",
            "key" : "LARGE_IMAGE_URL"
            }, {
            "description" : "Image - Original",
            "key" : "ORIGINAL_IMAGE_URL"
            }, {
            "description" : "Image - Additional View 1",
            "key" : "ADDITIONAL_IMAGE_1"
            }, {
            "description" : "Image - Additional View 2",
            "key" : "ADDITIONAL_IMAGE_2"
            }, {
            "description" : "Image - Additional View 3",
            "key" : "ADDITIONAL_IMAGE_3"
            }, {
            "description" : "Image - Additional View 4",
            "key" : "ADDITIONAL_IMAGE_4"
            }, {
            "description" : "Image - Additional View 1 Large",
            "key" : "XTRA_IMG_1_LARGE"
            }, {
            "description" : "Image - Additional View 2 Large",
            "key" : "XTRA_IMG_2_LARGE"
            }, {
            "description" : "Image - Additional View 3 Large",
            "key" : "XTRA_IMG_3_LARGE"
            }, {
            "description" : "Image - Additional View 4 Large",
            "key" : "XTRA_IMG_4_LARGE"
            }, {
            "description" : "Image",
            "key" : "IMAGE"
            } ],
            "disabled" : "false",
            "id" : "EditProductImage_productContentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productContentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Content Name",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "contentName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductImage_contentName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "disabled" : false,
            "id" : "EditProductImage_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "title":"Status ID",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "type" : "DISPLAY",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditProductImage",
            "options" : [ {
            "description" : "Pending",
            "key" : "IM_PENDING"
            }, {
            "description" : "Approved",
            "key" : "IM_APPROVED"
            }, {
            "description" : "Rejected",
            "key" : "IM_REJECTED"
            } ],
            "disabled" : "false",
            "id" : "EditProductImage_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Data Resource ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "dataResourceId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductImage_dataResourceId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "File",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "uploadedFile",
            "style" : "",
            "id" : "EditProductImage_uploadedFile",
            "value" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-02-20%2016:31:31.428",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditProductImage",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditProductImage_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
          }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Object Info",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "objectInfo",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductImage_objectInfo",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "textSize" : "25",
            "title" : "Thumb Nail Object Info",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "thumbNailObjectInfo",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditProductImage_thumbNailObjectInfo",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
          }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditProductImage",
            "tabindex" : "",
            "name" : "submit",
            "className" : "",
            "id" : "EditProductImage_submit",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateProductImage",
        "targets" : {
          "createTarget":"createProductImage",
          "updateTarget":"updateProductImage"
        }
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "resize", "uploadedFile", "productContentTypeId", "submit" ]
        } ],
        "formName" : "AddProductImage",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ImageManagementForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "AddProductImage_productId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "name" : "resize",
            "style" : "",
            "id" : "AddProductImage_resize",
            "title" : "Resize",
            "type" : "RADIO"
        }, {
            "fieldHelpText" : "",
            "maxlength" : "",
            "autocomplete" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "File",
            "type" : "FILE",
            "size" : "25",
            "alert" : "false",
            "name" : "uploadedFile",
            "style" : "",
            "id" : "AddProductImage_uploadedFile",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Product Content Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddProductImage",
            "options" : [ {
            "description" : "Default Original Image",
            "key" : "ORIGINAL_IMAGE_URL"
            }, {
            "description" : "Image - Additional View 1",
            "key" : "ADDITIONAL_IMAGE_1"
            }, {
            "description" : "Image - Additional View 2",
            "key" : "ADDITIONAL_IMAGE_2"
            }, {
            "description" : "Image - Additional View 3",
            "key" : "ADDITIONAL_IMAGE_3"
            }, {
            "description" : "Image - Additional View 4",
            "key" : "ADDITIONAL_IMAGE_4"
            }, {
            "description" : "Social Media - Feed Post Landscape",
            "key" : "ADDITIONAL_IMAGE_5"
            }, {
            "description" : "Social Media - Feed Post Portrait",
            "key" : "ADDITIONAL_IMAGE_6"
            }],
            "disabled" : "false",
            "id" : "AddProductImage_productContentTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productContentTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddProductImage",
            "tabindex" : "",
            "name" : "submit",
            "className" : "",
            "id" : "AddProductImage_submit",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createProductImage",
        "targets":{
            "createTarget":"createProductImage",
            "updateTarget":"createProductImage"
        }

    }
]